﻿import React from "react";
import {CSSTransition} from "react-transition-group";

export function FixedValidationMessage(props: { message: string }) {
    return <div className={"fixed-validation-message"}>
        <CSSTransition in={props.message != null} unmountOnExit timeout={150}>
            <p>{props.message}</p>
        </CSSTransition>
    </div>
}